/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AutocompleteTerm } from '../models/AutocompleteTerm';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AutocompleteTermService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves the collection of AutocompleteTerm resources.
     * Retrieves the collection of AutocompleteTerm resources.
     * @param q
     * @param types
     * @param limit
     * @param page The collection page number
     * @returns AutocompleteTerm AutocompleteTerm collection
     * @throws ApiError
     */
    public autocomplete(
        q: any,
        types?: Array<string>,
        limit: number = 10,
        page: number = 1,
    ): CancelablePromise<Array<AutocompleteTerm>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/autocomplete',
            query: {
                q: q,
                types: types,
                limit: limit,
                page: page,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
